import React from 'react';
import * as Styles from './ConfigurationGatorClaw.styles';
import useLocale from '@/hooks/useLocale';
import { Button, IconExternalLink, IconShieldTick } from 'gatorcomponents';
import { iconMap } from '@/pages/Products/VpsOciDetailPage/icons/iconMap';
import { useSelector } from 'react-redux';
import {
  executeSlugAction,
} from '@/pages/Products/VpsOciDetailPage/utils';

const ConfigurationGatorClaw = ({
  onShowConfigurationGatorClaw,
}) => {
  const vpsOci = useSelector(state => state.vpsOci);
  const { serverIp } = (vpsOci && vpsOci.data && vpsOci.data.ssh) || {};

  const { productDetails: productDetailsLocale } = useLocale();
  const { vpsOci: vpsOciLocale } = productDetailsLocale || {};
  const gatorClawLocale = (vpsOciLocale && vpsOciLocale.gatorClaw && vpsOciLocale.gatorClaw.configurationPage) || {};

  const {
    title: titleLocale,
    description: descriptionLocale,
    terms: {
      prefix: termsPrefixLocale,
      linkText: termsLinkTextLocale,
      suffix: termsSuffixLocale,
    } = {},
    buttons: {
      configure: configureButtonLocale,
    } = {},
    logoAlt: logoAltLocale,
    termsLinkUrl: termsLinkUrlLocale,
  } = gatorClawLocale;

  const handleConfigure = () => {
    if (onShowConfigurationGatorClaw) {
      onShowConfigurationGatorClaw(false);
    }

    executeSlugAction && executeSlugAction('gatorclaw', { serverIp });
  };

  return (
    <Styles.ConfigurationGatorClaw data-testid="vpsoci-configurationGatorClaw-gatorclaw-page">
      <Styles.Wrapper>
        <Styles.Header>
          <Styles.LogoWrapper data-name="GatorClaw Logo">
            <img src={iconMap.gatorclaw} alt={logoAltLocale} width={48} height={48} />
          </Styles.LogoWrapper>
          <Styles.Title data-testid="vpsoci-configurationGatorClaw-gatorclaw-title">
            {titleLocale}
          </Styles.Title>
        </Styles.Header>

        <Styles.Content>
          <Styles.Description data-testid="vpsoci-configurationGatorClaw-gatorclaw-description">
            {descriptionLocale}
          </Styles.Description>

          <Styles.TermsAlert data-name="Alert" data-testid="vpsoci-configurationGatorClaw-gatorclaw-terms-alert">
            <IconShieldTick size="md" color="primaryMedium" />
            <Styles.TermsText>
              {termsPrefixLocale}
              <Styles.TermsLink
                href={termsLinkUrlLocale}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="vpsoci-configurationGatorClaw-gatorclaw-terms-link"
              >
                {termsLinkTextLocale}
              </Styles.TermsLink>
              {termsSuffixLocale}
            </Styles.TermsText>
          </Styles.TermsAlert>
        </Styles.Content>

        <Styles.Actions>
          <Button
            label={configureButtonLocale}
            onClick={handleConfigure}
            variant="primary"
            size="large"
            width="full"
            iconRight={<IconExternalLink size="sm" color="highPure" secondaryColor="transparent" />}
            testId="vpsoci-configurationGatorClaw-gatorclaw-configure-button"
          />
        </Styles.Actions>
      </Styles.Wrapper>
    </Styles.ConfigurationGatorClaw>
  );
};

export default ConfigurationGatorClaw;
